import { Action } from '@Context/actions/action';
import { Actions } from "@Context/common/general/context";
import { AnalyticsEvents } from "@Enums";
import * as Sentry from "@sentry/react";

class GenericAction extends Action {
  constructor() {
    super(...arguments);
    // this.onLoad(this._payload);
    Sentry.addBreadcrumb({
      category: 'GenericAction',
      message: `Invoking GenericAction ${this.constructor.name}`,
      data: this._payload
    });
  }

  onLoad() {
    this._promiseResolve = Promise.resolve;
    this._loadPromise = new Promise((resolve) => {
      this._promiseResolve = resolve;
    });
    if (this._disableLoaders !== true)
      this._state.loading.events.enableLoader.emit(this._loadPromise);
  }

  onSuccess(response) {
    if (this._disableLoaders !== true)  {
      if(this._promiseResolve) {
        this._promiseResolve();
      } else {
        console.log('Promise resolve not found');
      }
    }
    const successPayload = {
      loading: { active: false },
    };
    if (this._disableLoaders !== true) {
      this._dispatch({
        type: Actions.CoreActions.UpdateState,
        payload: successPayload,
      });
    }
    if( this._onSuccess ) {
      this._onSuccess(response);
    }
  }

  onError(error = {}) {
    
    Sentry.captureException(error, {
      tags: {
        type: "generic-action",
        action_name: this.constructor.name,
        error_code: error.code || error.status,
        error_message: error.message,
        error_details: error.details || {},
      },
      fingerprint: [
        this.constructor.name,
        error.code,
        error.message
      ]
    });
    Sentry.flush();

    console.log('Sentry GenericAction Error sent', JSON.stringify(error));


    // Send error log to analytics services
    this._dispatch({
      type: Actions.AppActions.AnalyticsEvent,
      payload: {
        type: AnalyticsEvents.error_occured,
        data: error
      }
    });

    if (this._disableLoaders !== true && typeof this._promiseResolve === 'function') {
      this._promiseResolve();
    }
    else {
      this._dispatch({
        type: Actions.CoreActions.UpdateState,
        payload: {
          loading: { active: false },
        },
      });
    }
    
    if( this._onError ) {
      return this._onError(error);
    }

    this._dispatch({
      type: Actions.CoreActions.UpdateState,
      payload: {
        error: {
          active: true,
          title: error.details && error.details.code ? error.details.code : error.code || error.status,
          message: error.message,
          details: error.details,
        }
      }
    });
  }
};

export default GenericAction;
